var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNarrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow-narrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62427 8.82464C4.51175 8.93712 4.35917 9.00031 4.20007 9.00031C4.04097 9.00031 3.88838 8.93712 3.77587 8.82464L1.37587 6.42464C1.26338 6.31212 1.2002 6.15954 1.2002 6.00044C1.2002 5.84134 1.26338 5.68876 1.37587 5.57624L3.77587 3.17624C3.88903 3.06695 4.04059 3.00647 4.19791 3.00784C4.35523 3.0092 4.50571 3.0723 4.61696 3.18355C4.7282 3.29479 4.7913 3.44528 4.79267 3.6026C4.79404 3.75992 4.73356 3.91148 4.62427 4.02464L3.24847 5.40044H10.2001C10.3592 5.40044 10.5118 5.46365 10.6243 5.57618C10.7369 5.6887 10.8001 5.84131 10.8001 6.00044C10.8001 6.15957 10.7369 6.31218 10.6243 6.4247C10.5118 6.53723 10.3592 6.60044 10.2001 6.60044H3.24847L4.62427 7.97624C4.73675 8.08876 4.79994 8.24134 4.79994 8.40044C4.79994 8.55954 4.73675 8.71212 4.62427 8.82464Z",
    fill: "#616D8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNarrowLeft);
export default __webpack_public_path__ + "static/media/arrow-narrow-left.7abe0faad07a19b6456b441515819209.svg";
export { ForwardRef as ReactComponent };